<template>
  <div id="app">
    <transition :name="transitionName">
      <router-view />
    </transition>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { getUserDetail } from '@/api/api-user';

export default {
  created() {
    this.getUser();
    this.getUsesr();
  },
  methods: {
    ...mapActions(['getUser']),
    getUsesr() {
      getUserDetail().then(res => {
        if (res.status === 0 && this.$route.path !== '/ticket_check') {
          this.$router.push({ name: 'tickets_list' });
        }
      });
    },
  },
  // watch $route 决定使用哪种过渡
  watch: {
    $route(to, from) {
      const routeDeep = [
        'register',
        'index',
        'tickets_list',
        'orders_list',
        'user_info',
        'ticket_detail_list',
        'ticket_detail',
        'ticket_success',
        'user_info_index',
        'user_info_detail',
        'user_info_recharge',
        'user_info_recharge_list',
        'user_info_consume_list',
        'user_info_balance_list',
        'user_info_integral_list',
        'user_info_hours_list',
        'user_info_participation_list',
        'user_info_share',
        'user_info_rebate_list',
        'user_info_withdraw',
        'user_info_agent',
        'user_info_bonus_scan',
        'mylocker',
        'ticket_check',
        'ticket_check_result',
      ];
      this.transitionName =
        routeDeep.indexOf(to.name) > routeDeep.indexOf(from.name)
          ? 'fold-left'
          : 'fold-right';
    },
  },
  data() {
    return {
      transitionName: 'fold-left',
    };
  },
};
</script>

<style lang="less">
#app {
  width: 100%;
  min-height: 100%;
  position: absolute;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  overflow: hidden;
}
.fold-left-enter-active {
  animation-name: fold-left-in;
  animation-duration: 0.3s;
}
.fold-left-leave-active {
  animation-name: fold-left-out;
  animation-duration: 0.3s;
}
.fold-right-enter-active {
  animation-name: fold-right-in;
  animation-duration: 0.3s;
}
.fold-right-leave-active {
  animation-name: fold-right-out;
  animation-duration: 0.3s;
}
@keyframes fold-left-in {
  0% {
    transform: translate3d(100%, 0, 0);
  }
  100% {
    transform: translate3d(0, 0, 0);
  }
}
@keyframes fold-left-out {
  0% {
    transform: translate3d(0, 0, 0);
  }
  100% {
    transform: translate3d(-100%, 0, 0);
  }
}
@keyframes fold-right-in {
  0% {
    transform: translate3d(0, 0, 0);
  }
  100% {
    transform: translate3d(100%, 0, 0);
  }
}
@keyframes fold-right-out {
  0% {
    transform: translate3d(0, 0, 0);
  }
  100% {
    transform: translate3d(100%, 0, 0);
  }
}
</style>
